import React from 'react';
import SingleScenarioChart from './SingleScenarioChart';
import MultipleScenariosChart from './MultipleScenariosChart';

const LineChartCapture = ({ onCapture, costData, cppData, scenariosData, scenarios, currency }) => {
  // Check if we have multiple scenarios
  const hasMultipleScenarios = scenariosData && scenarios && scenarios.length > 1;

  return (
    <>
      {hasMultipleScenarios ? (
        <MultipleScenariosChart
          onCapture={onCapture}
          scenariosData={scenariosData}
          scenarios={scenarios}
          costData={costData}
          cppData={cppData}
          currency={currency}
        />
      ) : (
        <SingleScenarioChart
          onCapture={onCapture}
          costData={costData}
          cppData={cppData}
          currency={currency}
        />
      )}
    </>
  );
};

export default LineChartCapture;
